import React from 'react';
import './pageContent.scss';

export const ContentWrapper: React.FC = ({ children }) => {
  return <div className="page-content-wrapper">{children}</div>;
};
